"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _richTextField = require("../../lib/richTextField");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _dateFns = require("date-fns");
var _lodash = require("lodash");
var _constants = require("../../utils/constants");
var _linkFieldSrc = require("../../lib/linkFieldSrc");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Alert Component
 *
 * @param {object} props Properties used for the component
 *
 * @returns {React.ReactElement} An Alert
 */
function Alert(props) {
  var [showAlert, setShowAlert] = (0, _react.useState)(false);
  var {
    linkUrl,
    linkTarget
  } = (0, _linkFieldSrc.linkFieldSrc)(props.item.ctaLink.jss.value);
  var alertStorageKey = _constants.ALERT_NOTIFICATION.replace('[id]', props.item.id);
  (0, _react.useEffect)(() => {
    var wasClosedByUser = window.localStorage.getItem(alertStorageKey);
    var goodToOpen = (0, _lodash.isNull)(wasClosedByUser) ? true : (0, _dateFns.isPast)(new Date(parseInt(wasClosedByUser))) || (0, _dateFns.isSameDay)(new Date(parseInt(wasClosedByUser)), new Date());
    if (goodToOpen) setShowAlert(true);else setShowAlert(false);
  }, [alertStorageKey]);
  var handleClose = () => {
    var numberOfDays = (0, _lodash.isEmpty)(props.item.recurrence.targetItem.key.value) ? 1 : parseInt(props.item.recurrence.targetItem.key.value) === 0 ? (0, _dateFns.differenceInCalendarDays)(new Date(props.item.expireDate.jss.value), new Date()) + 2 : parseInt(props.item.recurrence.targetItem.key.value);
    window.localStorage.setItem(alertStorageKey, (0, _dateFns.getTime)((0, _dateFns.addDays)(new Date(), numberOfDays)));
    setShowAlert(false);
  };
  var args = {
    show: showAlert,
    heading: props.item.heading.value,
    hasIcon: props.item.showIcon.value ? true : false
  };
  args.onClose = handleClose;
  if (!(0, _lodash.isEmpty)(props.item.ctaText.value)) {
    args.link = {
      href: linkUrl,
      label: props.item.ctaText.value,
      target: linkTarget
    };
  }
  return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.AlertSite, _extends({}, args, {
    key: props.index
  }), (0, _richTextField.parseHTML)(props.item.text));
}
var _default = exports.default = Alert;